import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import documentIcon from '../../../../../../img/client/icons/document.svg';

/**
 * ProductLabelButton Component
 * Button to view product label/details in a new tab
 *
 * @param {Object} props
 * @param {string} props.productId - Product ID for navigation
 * @param {string} props.tooltip - Tooltip text
 * @param {boolean} [props.disabled=false] - Whether button is disabled
 * @param {number} [props.size=20] - Icon size
 * @param {number} [props.buttonSize=44] - Button size in pixels
 */
const ProductLabelButton = ({
  productId,
  tooltip,
  disabled = false,
  size = 20,
  buttonSize = 44,
}) => {
  const handleClick = () => {
    if (productId) {
      window.open(
        `/produits-commerciaux/details/${productId}`,
        '_blank',
        'noopener,noreferrer'
      );
    }
  };

  if (disabled || !productId) {
    return (
      <div
        style={{
          borderRadius: 8,
          width: buttonSize,
          height: buttonSize,
        }}
        className="flex items-center justify-center rounded-lg border border-[#F0F0F0] bg-[#FAFAFA] opacity-50"
      >
        <img
          src={documentIcon}
          alt="Document"
          width={size}
          height={size}
          className="opacity-30 pointer-events-none"
        />
      </div>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <button
        onClick={handleClick}
        style={{
          borderRadius: 8,
          width: buttonSize,
          height: buttonSize,
        }}
        className="flex items-center justify-center rounded-lg border border-[#D9D9D9] bg-white cursor-pointer transition-all hover:border-[#7CB305] hover:bg-[#F6FFED]"
      >
        <img
          src={documentIcon}
          alt="Document"
          width={size}
          height={size}
          className="pointer-events-none"
        />
      </button>
    </Tooltip>
  );
};

ProductLabelButton.propTypes = {
  productId: PropTypes.string,
  tooltip: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.number,
  buttonSize: PropTypes.number,
};

export default React.memo(ProductLabelButton);
